import React from 'react';

const Education = () => {
  return (
    <section id="education" className="my-16 p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md transition-colors duration-300">
      <h2 className="text-3xl font-semibold text-blue-600 dark:text-blue-400">Education</h2>
      <div className="mt-4 border-l-4 border-blue-500 pl-4">
        <h3 className="text-xl font-bold dark:text-white">B.S. Information Technology - Network Security</h3>
        <p className="text-gray-600 dark:text-gray-400 italic">Expected Graduation: 2026</p>
        <ul className="mt-2 list-disc list-inside text-gray-700 dark:text-gray-300 space-y-1">
          <li>Maintaining strong class standing and pushing for top marks in rigorous coursework, especially Sir Mc's classes.</li>
          <li>Focus areas: Network Engineering (OSPF, NAT, ACLs), Data Science (Machine Learning evaluation), and Information Security.</li>
          <li>Researching indigenous knowledge systems, including the historical context of the Cordillera region and the Mount Data Peace Accord.</li>
        </ul>
      </div>
    </section>
  );
};

export default Education;